export default __webpack_public_path__ + "static/14-fbc258d60200e8dcf6ba9e5bbb2ccebf.jpg";